import { sendEvent } from './add-activity-stream-event';

const timestamp = () => new Date().toISOString();

export type UIInteractionEventParams = {
  partitionKey: string;
  sourceApplication: string;
};

export interface UIEvents {
  CreateContentCollection: { view: string };
  AddContentToCollection: { view: string };
  DeleteContentCollection: { view: string };
}

const useUIInteractionEvents = ({ partitionKey, sourceApplication }: UIInteractionEventParams) => {
  const uiInteractionEvent = <K extends keyof UIEvents>(eventType: K, uiEventContext: UIEvents[K]): void => {
    const { view, ...contextWithoutView } = uiEventContext as UIEvents[K] & { view?: string };
    sendEvent({
      partitionKey,
      sourceApplication,
      type: 'UIInteractionEventV1',
      payload: {
        sessionId: partitionKey,
        timestamp: timestamp() as any,
        eventType,
        // @ts-ignore
        data: contextWithoutView,
        ...(view && { view }),
      },
    });
  };

  return {
    uiInteractionEvent,
  };
};

export default useUIInteractionEvents;
